import { render, staticRenderFns } from "./curriculumProposal.vue?vue&type=template&id=e744d630&scoped=true"
import script from "./curriculumProposal.vue?vue&type=script&lang=js"
export * from "./curriculumProposal.vue?vue&type=script&lang=js"
import style0 from "./curriculumProposal.vue?vue&type=style&index=0&id=e744d630&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e744d630",
  null
  
)

export default component.exports